import { useQuery } from '@tanstack/react-query';

import { getLearnBlogArticle, GetLearnBlogArticleParams } from '@arrived/api_v2';

import { MAX_STALE_TIME } from '../queries.utils';
import { learnBlogArticleKey } from './learnBlog.keys';

export function useLearnBlogArticleQuery(params: GetLearnBlogArticleParams) {
  return useQuery(
    // Don't know if this is best way to bust this one
    learnBlogArticleKey(params),
    () => getLearnBlogArticle(params),
    {
      staleTime: MAX_STALE_TIME,
      enabled: !!(params?.id || params?.slug),
    }
  );
}
